
(function() {
	
	$(window)
		.on('scroll', function () {
			setTimeout(() => {
			}, 1000);
			IndexScroll();
		})
		.on('resize', function () {
			IndexScroll();
		});

		
			
		var win = $(window),
			ww = win.innerWidth(),
			wh = win.innerHeight(),
			window_width = win.width(),
			ws = win.scrollTop();
		var resizeWindow = function(){
			ww = win.innerWidth();
			wh = win.innerHeight();
		}
		// -----------------------------------
		// 頁面滾動時的動畫判斷
		// -----------------------------------
		function IndexScroll(){
			// // 頁面滾動時的動畫判斷
			var $animation_elements = $('.js-ani');
			var window_w = win.width();
			var window_height = win.height();
			var window_top_position = win.scrollTop();
			var window_bottom_position = (window_top_position + window_height / 4);
			var window_bottom_position_m = (window_top_position + window_height);
	
			$.each($animation_elements, function() {
				var $element = $(this);
				var element_height = $element.outerHeight();
				var element_top_position = $element.offset().top;
				var element_bottom_position = (element_top_position + element_height);
	
				if(window_w > 1024){
					//check to see if this current container is within viewport
					if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
						$animation_elements.removeClass('is-animated');
						$element.addClass('is-animated');
					}else{
						$element.removeClass('is-animated');
					}

			
					if($('.s_ctr.ip').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('ip');
						$('.bgitem').removeClass('is-scrollon');
					}else if($('.s_ctr.marcomm1').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar2').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('mar1');
						$('.bgitem').addClass('is-scrollon');
					}else if($('.s_ctr.marcomm2').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('mar2');
						$('.bgitem').addClass('is-scrollon');
					}else if($('.s_ctr.marcomm3').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('mar3');
						$('.bgitem').addClass('is-scrollon');
					}else if($('.s_ctr.marcomm4').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar5');
						$('.bnpic').addClass('mar4');
						$('.bgitem').addClass('is-scrollon');
					}else if($('.s_ctr.marcomm5').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar4');
						$('.bnpic').addClass('mar5');
						$('.bgitem').addClass('is-scrollon');
					}else{
						$('.bnpic').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('show');
						$('.bgitem').removeClass('is-scrollon');
					}
				}else{
					//check to see if this current container is within viewport
					if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position_m)) {
						$animation_elements.removeClass('is-animated');
						$element.addClass('is-animated');
					}else{
						$element.removeClass('is-animated');
					}
					
			
					if($('.s_ctr.ip').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('ip');
					}else if($('.s_ctr.marcomm1').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar2').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('mar1');
					}else if($('.s_ctr.marcomm2').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar3').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('mar2');
					}else if($('.s_ctr.marcomm3').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar4').removeClass('mar5');
						$('.bnpic').addClass('mar3');
					}else if($('.s_ctr.marcomm4').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar5');
						$('.bnpic').addClass('mar4');
					}else if($('.s_ctr.marcomm5').hasClass('is-animated') == true){
						$('.bnpic').removeClass('show').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar3').removeClass('mar4');
						$('.bnpic').addClass('mar5');
					}else{
						$('.bnpic').removeClass('ip').removeClass('mar1').removeClass('mar2').removeClass('mar3');
						$('.bnpic').addClass('show');
					}
				}
			});
		}

})();

document.addEventListener('DOMContentLoaded', function() {
    // 找到滾動容器元素
    const scrollContainer = document.getElementById('scrollContainer');
    
    // 取得所有 .stepcont-box 元素
    const boxes = document.querySelectorAll('.stepcont-box');
    
    // 找到具有 .is-active 的元素
    const activeBox = document.querySelector('.stepcont-box.is-active');
    
    // 判斷 activeBox 是第幾個
    let activeIndex = Array.from(boxes).indexOf(activeBox);

    // 計算應該滾動到的位置
    if (activeIndex !== -1) {
        // 每個盒子的基礎寬度 220px，重疊部分 15px
        const baseWidth = 220;
        const overlap = 30;
        
        // 計算滾動距離： (index * 220) + ((index - 1) * 15)
        let scrollDistance = (activeIndex * baseWidth) + ((activeIndex - 1) * overlap);
        
        // 如果是第一個，重疊部分不應存在，所以要保證 index > 0
        if (activeIndex === 0) {
            scrollDistance = 0;
        }
        
        // 設定 scrollLeft 的值，使得容器滾動到該位置
        scrollContainer.scrollLeft = scrollDistance;
    }
});


$(document).ready(function () {
	new Swiper('.swiper-container.commslider', {
	  loop: !1,
	  autoplayDisableOninteraction: false,
	  spaceBetween: 0,
	  slidesPerView: 1,
	  autoHeight: !0,
	  watchSlidesVisibility: true, //防止不可点击
	  touchRatio: 0.08,
	  watchSlidesProgress: true,
	  simulateTouch: !0,
	  preventClicks: !0,
	  followFinger: !1,
	  resistance: !1,
	  navigation: { nextEl: ".marslider .swiper-arrow.next", prevEl: ".marslider .swiper-arrow.prev" },
	  loopAdditionalSlides: 1,
	  pagination: { el: ".swiper-container.commslider .swiper-pagination", clickable: !0 },
	  slideToClickedSlide: !0 });
	new Swiper('.swiper-container.bncont-slider', {
	  loop: !1,
	  autoplayDisableOninteraction: false,
	  spaceBetween: 0,
	  slidesPerView: 1,
	  autoHeight: !0,
	  watchSlidesVisibility: true, //防止不可点击
	  touchRatio: 0.08,
	  watchSlidesProgress: true,
	  simulateTouch: !0,
	  preventClicks: !0,
	  followFinger: !1,
	  resistance: !1,
	  navigation: { nextEl: ".bncont-slider .swiper-arrow.next", prevEl: ".bncont-slider .swiper-arrow.prev" },
	  loopAdditionalSlides: 1,
	  pagination: { el: ".swiper-container.bncont-slider .swiper-pagination", clickable: !0 },
	  slideToClickedSlide: !0 });
	
	var onecardSliderVideo = new Swiper('.swiper-container.media', {
		loop: !1,
		autoplayDisableOninteraction:false,
		spaceBetween: 80,
		slidesPerView: 1,
		autoHeight: !0,
		watchSlidesVisibility: true,//防止不可点击
		touchRatio: 0.08,
		watchSlidesProgress: true,
		simulateTouch:!0,
		preventClicks:!0,
		followFinger:!1,
		resistance:!1,
		navigation:{nextEl:".swiper-container.media .swiper-arrow.next",prevEl:".swiper-container.media .swiper-arrow.prev"},
		loopAdditionalSlides:1,
		pagination:{el:".swiper-container.media .swiper-pagination",clickable:!0},
		slideToClickedSlide: !0,
	});

	// FAQ切換判斷
	$('.qabox-cont').on('click', function () {
	  if ($(this).hasClass('is-active') == false) {
		$('.qabox-cont').removeClass('is-active');
		$(this).addClass('is-active');
	  } else {
		$(this).removeClass('is-active');
	  }
	});

	// 立即購買跳轉
	$('a[href="#BuyNow"]').on('click',function(event) {
		event.preventDefault();
		$('html, body').animate({ scrollTop: $('#BuyNow').offset().top }, 'slow');
	});

}); /* end document */
